import axios from "axios";
import { END_POINT } from "../../../../constants/defaultValues";

const getToken = () => localStorage.getItem("access_token");
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

/**
 * Fetch paginated product list
 */
export const fetchProducts = (selectedPageSize, currentPage, search) => {
  return axios
    .get(
      `${END_POINT}/product/json?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
      authHeader(),
    )
    .then((res) => res.data);
};

/**
 * Fetch all categories
 */
export const fetchCategories = () => {
  return axios
    .get(`${END_POINT}/category`, authHeader())
    .then((res) => res.data.data)
    .catch(() => []);
};

/**
 * Fetch all stock units
 */
export const fetchStockUnits = () => {
  return axios
    .get(`${END_POINT}/stock/all-unit`, authHeader())
    .then((res) => res.data.data)
    .catch((err) => {
      console.error("Lỗi khi lấy danh sách đơn vị (fail-safe):", err.response || err.message);
      return [];
    });
};

/**
 * Fetch all make-products (cost/recipe templates)
 */
export const fetchMakeProducts = () => {
  return axios
    .get(`${END_POINT}/make-product/all`, authHeader())
    .then((res) => res.data.data)
    .catch((err) => {
      console.error("Lỗi khi lấy danh sách make product (fail-safe):", err.response || err.message);
      return [];
    });
};

/**
 * Fetch all products (non-paginated)
 */
export const fetchAllProducts = () => {
  return axios
    .get(`${END_POINT}/product/all`, authHeader())
    .then((res) => res.data.data);
};

/**
 * Fetch providers
 */
export const fetchProviders = () => {
  return axios
    .get(`${END_POINT}/company-provider`, authHeader())
    .then((res) => res.data.data)
    .catch(() => []);
};

/**
 * Fetch soft-deleted products
 */
export const fetchSoftDeletedProducts = () => {
  return axios
    .get(`${END_POINT}/product/all-soft-delete`, authHeader())
    .then((res) => res.data);
};

/**
 * Fetch soft-deleted stocks
 */
export const fetchSoftDeletedStocks = () => {
  return axios
    .get(`${END_POINT}/stock/all-soft-del`, authHeader())
    .then((res) => res.data);
};

/**
 * Fetch user business type
 */
export const fetchBusinessType = () => {
  return axios
    .get(`${END_POINT}/user/business-type`, authHeader())
    .then((res) => res.data.data);
};

/**
 * Fetch user license info
 */
export const fetchLicense = () => {
  return axios
    .get(`${END_POINT}/user-license`, authHeader())
    .then((res) => res.data.data);
};

/**
 * Create product (multipart form data)
 */
export const createProduct = (formData) => {
  return axios.post(`${END_POINT}/product`, formData, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "content-type": "multipart/form-data",
    },
  });
};

/**
 * Update product (multipart form data)
 */
export const updateProduct = (formData) => {
  return axios.post(`${END_POINT}/product/update`, formData, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "content-type": "multipart/form-data",
    },
  });
};

/**
 * Delete product by ID
 */
export const deleteProduct = (id) => {
  return axios.delete(`${END_POINT}/product/${id}`, authHeader());
};

/**
 * Soft delete (hide) product
 */
export const softDeleteProduct = (id) => {
  return axios.put(`${END_POINT}/product/soft-delete/${id}`, {}, authHeader());
};

/**
 * Toggle bestseller status
 */
export const toggleBestseller = (id) => {
  return axios.put(`${END_POINT}/product/bestter/${id}`, {}, authHeader());
};

/**
 * Bulk update products
 */
export const bulkUpdateProducts = (products) => {
  return axios.put(`${END_POINT}/product/bulk-update`, { products }, authHeader());
};

/**
 * Import products
 */
export const importProducts = (productData) => {
  return axios.post(`${END_POINT}/product/import-product`, { productData }, authHeader());
};

/**
 * Create/Update make-product (cost recipe)
 */
export const saveMakeProduct = (productId, stocks, dynamicForm) => {
  const body = { product_id: productId, stocks };
  if (dynamicForm) body.dynamic_form = dynamicForm;
  return axios.post(`${END_POINT}/make-product`, body, authHeader());
};

/**
 * Create category
 */
export const createCategory = (name, dynamicForm) => {
  return axios.post(`${END_POINT}/category`, {
    name,
    ...(dynamicForm !== undefined ? { dynamic_form: dynamicForm } : {}),
  }, authHeader());
};

/**
 * Delete category
 */
export const deleteCategory = (id) => {
  return axios.delete(`${END_POINT}/category/${id}`, authHeader());
};

/**
 * Save product recipe
 */
export const saveRecipe = (productId, ingredients) => {
  return axios.post(
    `${END_POINT}/product/recipe`,
    { product_id: productId, ingredients },
    authHeader(),
  );
};
